module.exports = __webpack_public_path__ + "static/koenigsberg-bad915e7ffbc2bd615910a0dd8e18823.png";